<div class="card request-selector-card">
    <div class="card-body request-detail-category-selector-container d-flex flex-column flex-md-row">
        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [for]="REQUEST_DETAIL_CATEGORY.INFO">
            <input class="d-none" type="radio" kendoRadioButton size="large"
                [id]="REQUEST_DETAIL_CATEGORY.INFO" 
                name="categoryGroup" 
                [value]="REQUEST_DETAIL_CATEGORY.INFO" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <i class="app-icon icon icon-car icon-xl"></i>
            <span>{{'requests.details.category.info' | translate}}</span>
        </label>

        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [for]="REQUEST_DETAIL_CATEGORY.DOCUMENTS">
            <input class="d-none" type="radio" kendoRadioButton size="large" 
                [id]="REQUEST_DETAIL_CATEGORY.DOCUMENTS"
                name="categoryGroup" 
                [value]="REQUEST_DETAIL_CATEGORY.DOCUMENTS" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <i class="app-icon icon icon-contract-1 icon-xl"></i>
            <span>{{'requests.details.category.documents' | translate}}</span>
        </label>

        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [for]="REQUEST_DETAIL_CATEGORY.COMMENTS">
            <input class="d-none" type="radio" kendoRadioButton size="large" 
                [id]="REQUEST_DETAIL_CATEGORY.COMMENTS"
                name="categoryGroup" 
                [value]="REQUEST_DETAIL_CATEGORY.COMMENTS" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <i class="app-icon icon icon-bubble-chat icon-xl"></i>
            <span>{{'requests.details.category.comments' | translate}}</span>
        </label>
    </div>
</div>